"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepTypeConfig = void 0;
const react_1 = require("@thesisedu/react");
const react_2 = __importDefault(require("react"));
const stepTypes_1 = require("../step/stepTypes");
function StepTypeConfig({ prefix }) {
    const { form } = react_1.Form.useReactFormContext();
    const type = form.watch(`${prefix}.type`);
    const info = type ? stepTypes_1.STEP_TYPES[type] : undefined;
    if (info) {
        return react_2.default.createElement(info.renderConfiguration, { prefix: prefix });
    }
    else {
        return null;
    }
}
exports.StepTypeConfig = StepTypeConfig;
//# sourceMappingURL=StepTypeConfig.js.map